module.exports = __webpack_public_path__ + "static/media/Inspiron_winners.e3ddd473.png";